import React from "react";

const IconColoredCalendar = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 27 27"
    >
      <g
        id="Group_1961"
        dataname="Group 1961"
        transform="translate(-474 -706.176)"
      >
        <g
          id="Group_1486"
          dataname="Group 1486"
          transform="translate(-584 182.176)"
        >
          <circle
            id="Ellipse_227"
            dataname="Ellipse 227"
            cx="13.5"
            cy="13.5"
            r="13.5"
            transform="translate(1058 524)"
            fill="#cfc"
          />
        </g>
        <g id="fi-rr-calendar" transform="translate(481 713.176)">
          <path
            id="Path_3797"
            dataname="Path 3797"
            d="M10.291,1.083H9.75V.542a.542.542,0,0,0-1.083,0v.542H4.333V.542a.542.542,0,1,0-1.083,0v.542H2.708A2.711,2.711,0,0,0,0,3.792v6.5A2.711,2.711,0,0,0,2.708,13h7.583A2.711,2.711,0,0,0,13,10.291v-6.5A2.711,2.711,0,0,0,10.291,1.083ZM1.083,3.792A1.625,1.625,0,0,1,2.708,2.167h7.583a1.625,1.625,0,0,1,1.625,1.625v.542H1.083Zm9.208,8.125H2.708a1.625,1.625,0,0,1-1.625-1.625V5.416H11.916v4.875A1.625,1.625,0,0,1,10.291,11.916Z"
            fill="#359035"
          />
          <circle
            id="Ellipse_250"
            dataname="Ellipse 250"
            cx="0.812"
            cy="0.812"
            r="0.812"
            transform="translate(5.687 7.312)"
            fill="#359035"
          />
          <circle
            id="Ellipse_251"
            dataname="Ellipse 251"
            cx="0.812"
            cy="0.812"
            r="0.812"
            transform="translate(2.979 7.312)"
            fill="#359035"
          />
          <circle
            id="Ellipse_252"
            dataname="Ellipse 252"
            cx="0.812"
            cy="0.812"
            r="0.812"
            transform="translate(8.396 7.312)"
            fill="#359035"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconColoredCalendar;
